import { combineReducers } from 'redux';
import { modalNotificationsSlice, ModalNotificationsState } from './modalNotifications';
import { snackbarSlice, SnackbarState } from './snackbar';

export interface ControlsState {
    snackbar: SnackbarState;
    modalNotifications: ModalNotificationsState;
}

export const controls = combineReducers<ControlsState>({
    snackbar: snackbarSlice.reducer,
    modalNotifications: modalNotificationsSlice.reducer,
});
